import React from 'react';

function Invoice2() {
  return (
    <>
      <section className="inv2-container">
        <h1 className="inv-H2">Manage Invoices</h1>
        <a className="All-2">All</a>
        <a className="pending-2">Pending</a>
        <a className="completed-2">Completed</a>
        <input type="text" name="search3" placeholder="Search" id="search3" className="search3" required />
        <h2 className="inv-H3">This Week</h2>
        <input type="text" name="INV5" placeholder="" id="INV5" className="INV5" required />
        <input type="text" name="INV6" placeholder="" id="INV6" className="INV6" required />
        <input type="text" name="INV7" placeholder="" id="INV7" className="INV7" required />
        <input type="text" name="INV8" placeholder="" id="INV8" className="INV8" required />
        <a className="back-home3" href="#">Back To Home</a>


      </section>
    </>
  );
}

export default Invoice2;
